import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import { Table } from "../../../../../components/table/Table";
import { getRequestedDevicesForTable } from "../../../../../store/devices/devices.selectors";
import { NotMobile, Mobile } from "../../../../../hocs/Responsive";
import { useIntlTranslate } from "../../../../../hooks";
import {
  COLUMNS,
  COLUMNS_MOBILE,
  SEARCH_KEYS,
} from "./RequestedDevicesTable.consts";
import { RequestedDevicesTableHeader } from "./components";

export const RequestedDevicesTable = () => {
  const devices = useSelector(getRequestedDevicesForTable, _.isEqual);
  const translate = useIntlTranslate();
  const caption = translate("new_requests");

  return (
    <Fragment>
      <Mobile>
        <Table
          header={<RequestedDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          visibleHeader={false}
          columns={COLUMNS_MOBILE}
          data={devices}
          hiddenColumns={["manufacturer", "id"]}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Mobile>
      <NotMobile>
        <Table
          header={<RequestedDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          columns={COLUMNS}
          data={devices}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </NotMobile>
    </Fragment>
  );
};
